import React, { useState, useEffect } from 'react';
import Header2 from './Header2';
import Footer2 from './Footer2';
import ContactBar from './ContactBar';
import bgImage from '../assets/bgImage.png';
import { FaRegEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { IoLocationSharp } from 'react-icons/io5';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../CSS/EvaBanquet.css';

// Sample images for the glimpse section
import glimpseImage1 from '../assets/LIBRA EVENTS/1465.jpg'; 
import glimpseImage2 from '../assets/LIBRA EVENTS/_DSC9636.jpg';
import glimpseImage3 from '../assets/LIBRA EVENTS/new/IMG-20250820-WA0004.jpg';
import glimpseImage4 from '../assets/LIBRA EVENTS/KSH_0591.jpg';
import glimpseImage5 from '../assets/LIBRA EVENTS/KSH_9661.jpg';
import glimpseImage6 from '../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.43 PM (2).jpeg';
import glimpseImage7 from '../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.44 PM.jpeg';

// Images for the details section (replacing the PDF)
import brochureImage1 from '../assets/LIBRA EVENTS/1465.jpg';
import brochureImage2 from '../assets/LIBRA EVENTS/_DSC9636.jpg';
import brochureImage3 from '../assets/LIBRA EVENTS/KSH_0591.jpg';
import brochureImage4 from '../assets/LIBRA EVENTS/KSH_9661.jpg';
import brochureImage5 from '../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.43 PM (2).jpeg';
import brochureImage6 from '../assets/LIBRA EVENTS/WhatsApp Image 2023-12-15 at 7.15.44 PM.jpeg';
import brochureImage7 from '../assets/LIBRA EVENTS/KSH_2988.jpg';
import brochureImage8 from '../assets/LIBRA EVENTS/KSH_4829.jpg';
import brochureImage9 from '../assets/LIBRA EVENTS/KSH_7687.jpg';
import brochureImage10 from '../assets/LIBRA EVENTS/_PHP0450.jpg';
import brochureImage11 from '../assets/Great-Ballroom-1-Kolkata.jpg';
import brochureImage12 from '../assets/LIBRA EVENTS/WhatsApp Image 2024-02-03 at 10.36.56 AM (1).jpeg';
import { FaLocationDot } from 'react-icons/fa6';


const glimpseImages = [glimpseImage1, glimpseImage2, glimpseImage3, glimpseImage4, glimpseImage5, glimpseImage6,glimpseImage7];
const brochureImages = [brochureImage1, brochureImage2, brochureImage3, brochureImage4, brochureImage5, brochureImage6, brochureImage7, brochureImage8, brochureImage9, brochureImage10, brochureImage11, brochureImage12];

const EvaBanquet = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handlePrev = () => {
        setCurrentImageIndex((prevIndex) => 
            prevIndex === 0 ? glimpseImages.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentImageIndex((prevIndex) => 
            prevIndex === glimpseImages.length - 1 ? 0 : prevIndex + 1
        );
    };

    return (
        <div>

            <Header2 />
            
            {/* Hero Section */}
            <section
                className="eva-hero-section"
                style={{ backgroundImage: `url(${bgImage})` }}
            >
                <div className="eva-overlay container">
                    <p className="eva-subtitle">MODERN SPACE</p>
                    <h1 className="eva-title">
                        <span className="highlight">EVA</span> BANQUET
                    </h1>
                    <div className="eva-breadcrumbs mt-3">
                        <a href='/' className="home-link"><span className="eva-home">Home</span></a>
                        <span className="eva-divider"> | </span>
                        <span className="eva-about">Eva Banquet</span>
                    </div>
                </div>
            </section>

            {/* Glimpse & Location Section */}
            <section className="eva-glimpse-section py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <h2 className="section-heading">Eva Banquets <span>Glimpse</span></h2>
                            <div className="glimpse-image-container mb-4">
                                <img src={glimpseImages[currentImageIndex]} alt="Eva Banquets Glimpse" className="img-fluid rounded shadow" />
                                <button className="eva-glimpse-nav-button eva-glimpse-nav-left" onClick={handlePrev}>
                                    <FaChevronLeft />
                                </button>
                                <button className="eva-glimpse-nav-button eva-glimpse-nav-right" onClick={handleNext}>
                                    <FaChevronRight />
                                </button>
                            </div>
                            <p className="glimpse-text">
                                <strong>Eva Banquets</strong> is one of the best event venues in Vadodara, offering an elegant and versatile space for every occasion — from weddings and receptions to corporate events and social gatherings.
                            </p>
                            <p className="glimpse-text">
                                With three beautiful indoor banquets — Lotus, Lily, and Lilac — Eva can accommodate up to 1700 guests, making it ideal for both intimate and grand celebrations. The venue features brightly lit interiors, a spacious courtyard garden, and stunning décor that blends luxury with comfort.
                            </p>
                            <p>
                                Our expert chefs craft delightful menus tailored to your taste, while our event management team ensures a seamless and memorable experience. Whether indoor or outdoor, Eva Banquets in Manjalpur, Vadodara, promises perfection in every celebration.
                            </p>
                        </div>
                        <div className="col-lg-4">
                            <div className="location-card rounded p-4 shadow">
                                <h3 className="location-heading">Venue Location</h3>
                                <iframe 
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3692.1513113692577!2d73.1877681!3d22.272257399999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc5dc2bde1cfd%3A0xa435e654a2557c24!2sEva%20Banquet!5e0!3m2!1sen!2sin!4v1755149279257!5m2!1sen!2sin"
                                    width="100%"
                                    height="250"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                ></iframe>
                                <div className="contact-info mt-3">
                                    <p><FaLocationDot /> Basement, 1, Eva Mall Rd,<br/>
                                    near Saraswati Complex, <br/>
                                    Patidar Crossing, Manjalpur, 
                                    Vadodara, Gujarat 390011</p>
                                    <p><FaPhoneAlt /> +91 9825077188</p>
                                    <p><FaRegEnvelope /> libraeventsdecorators@gmail.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            {/* Brochure Details Section - now with an image grid */}
            <section className="eva-details-section py-5">
                <div className="container text-center">
                    <h2 className="section-heading">Eva Banquets <span2>In</span2> <span>Details</span></h2>
                    <div className="brochure-grid my-4">
                        {brochureImages.map((imgSrc, index) => (
                            <div key={index} className="brochure-item">
                                <img src={imgSrc} alt={`Brochure Image ${index + 1}`} className="img-fluid rounded shadow" />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            
            <ContactBar />
            <Footer2 />
        </div>
    );
};

export default EvaBanquet;